<template>
  <v-dialog v-model="showDialog" max-width="75%">
    <v-toolbar dark color="primary">
      <v-toolbar-title>{{ this.prescriber }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click.stop="showDialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card tile>
      <v-card-text class="pb-1">
        <v-row v-if="this.requestError == true && this.loading != true">
          <v-col>
            <v-alert type="error">Error getting Prescriber details.</v-alert>
          </v-col>
        </v-row>
        <v-row v-else>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-data-table
            :loading="load"
            :headers="headers"
            :items="prescriber_data"
            :search="search"
            :sort-desc="[true]"
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, -1]
            }"
            :items-per-page="10"
            loading-text="Loading data..."
            class="elevation-0 col-md-12 m-auto"
          >

          <template v-slot:item.AMOUNT="{ item }">
            {{ "$" + item.AMOUNT.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,") }}
          </template>

          <template v-slot:item.QUANTITY="{ item }">
            {{ parseInt(item.QUANTITY) }}
          </template>

          <template v-slot:item.DAYS_SUP="{ item }">
            {{ parseInt(item.DAYS_SUP) }}
          </template>

          </v-data-table>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  name: 'prescriberDetails',
  props: [
    'value',
    'insurance',
    'prescriberID',
    'prescriber',
    'groups',
    'providers',
    'locations',
    'start',
    'end',
  ],
  data() {
    return {
      search: '',
      load: false,
      headers: [
        { text: 'Claim ID', value: 'CLAIM_ID' },
        { text: 'Provider Name', value: 'PROV_NAME' },
        { text: 'Patient Name', value: 'PAT_NAME' },
        { text: 'DOB', value: 'DOB' },
        { text: 'Month Filled', value: 'MONTH_FILLED' },
        { text: 'Pharmacy', value: 'PHARMACY' },
        { text: 'Drug Name', value: 'DRUG_NAME' },
        { text: 'Interchange Drug', value: 'INTERCHANGE_DRUG' },
        { text: 'Quantity', value: 'QUANTITY' },
        { text: 'Days Supply', value: 'DAYS_SUP' },
        { text: 'Amount', value: 'AMOUNT' },
      ],
      dialog: false,
      loading: true,
      requestError: false,
      prescriber_data: [],
    };
  },
  methods: {
    async getPrescriberInfo() {
      this.load = true;
      this.requestError = false;
      this.prescriber_data = [];

      const provNums = this.providers;
      let providers = [];
      if (provNums.length > 0) {
        provNums.forEach((prov) => {
          if (providers.indexOf(prov.Center_PCP_Number) === -1) {
            providers.push(prov.Center_PCP_Number);
          }
        });
      } else {
        providers = [];
      }

      const locs = this.locations;
      let locations = [];
      if (locs.length > 0) {
        locs.forEach((loca) => {
          if (locations.indexOf(loca.Center_Location) === -1) {
            locations.push(loca.Center_Location);
          }
        });
      } else {
        locations = [];
      }

      const url = `api/modal/highcost/prescriber/details/groups=${this.groups}/providers=${providers}/locs=${locations}/${this.insurance}/${this.prescriberID}/${this.start}/${this.end}`;
      const response = axios
        .get(url)
        .then((response) => {
          this.prescriber_data = response.data.data;
          this.load = false;
        })
        .catch((error) => {
          this.requestError = true;
          this.load = false;
        });
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    async prescriberID() {
      if (this.prescriberID != null && this.prescriberID != 0 && this.prescriberID != '') {

        this.getPrescriberInfo();
      }
    }
  },
};
</script>

<style>
.code-list {
  list-style-type: none;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
